import Box from "@mui/material/Box";
import { toChipColourSx } from "@/app/chip.utils";
import { OverflowTooltip } from "@/components/OverflowTooltip";
import { orderListSystemChipHue } from "./orderListSystemChipColour";

interface OrderListSystemChipProps {
  system: string;
}

/** A system's code (CIN7, TOLL, …) in its fixed colour, on a soft tint of it. */
export const OrderListSystemChip = (props: OrderListSystemChipProps) => {
  const { system } = props;
  const hue = orderListSystemChipHue(system);

  return (
    <OverflowTooltip title={system}>
      <Box
        sx={[
          toChipColourSx(hue),
          {
            borderRadius: 0.5,
            display: "inline-block",
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: "0.05em",
            lineHeight: "20px",
            maxWidth: "100%",
            minWidth: 56,
            overflow: "hidden",
            px: 0.75,
            textAlign: "center",
            textOverflow: "ellipsis",
            verticalAlign: "middle",
            whiteSpace: "nowrap",
          },
        ]}
      >
        {system}
      </Box>
    </OverflowTooltip>
  );
};
